var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnChainPermissions } from "healthex-common/auth.dtos";
import { UserType } from "healthex-common/user.dtos";
import { autorun, computed, observable } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { SimpleDialogModel } from "../SimpleDialogModel";
import { GlobalAdminUserFormModelBase } from "./GlobalAdminUserFormModelBase";
export class ProvisionAddressDialogModel extends SimpleDialogModel {
    onChoice(choice) {
        if (choice) {
            this.lastSelectedChoice = choice;
            this.open = true;
        }
        else {
            super.onChoice(choice);
        }
    }
}
export class GlobalAdminHealthcareOrganizationUserFormModel extends GlobalAdminUserFormModelBase {
    constructor(opts) {
        super(opts);
        this.userInput = {
            email: "",
            phone: "",
            firstName: "",
            lastName: "",
            title: "",
            permissions: [],
            onChainAddress: "",
            avatarUrl: "",
            newAvatar: null,
        };
        this.isUserInvited = false;
        this.organizationsManager = opts.container.organizationsManager;
        autorun(async () => {
            if (this.opts.mode === "detail") {
                this.isUserInvited = await this.organizationsManager.isUserInvited(this.opts.userId);
            }
        });
    }
    get blockchainAddressText() {
        if (this.opts.mode === "detail") {
            if (this.isUserInvited) {
                return "User has been sent an invite to provision Blockchain Address";
            }
            return this.userInput.onChainAddress;
        }
        return "";
    }
    updateUserInput(update) {
        this.userInput = { ...this.userInput, ...update };
    }
    async loadUser(organizationId, userId, reload) {
        var _a;
        if (reload) {
            await this.organizationsManager.waitForReloadOrganizations();
        }
        const organization = this.organizationsManager.getOrganization(organizationId);
        if (organization === NOT_LOADED || !organization)
            return;
        const user = (_a = organization.users) === null || _a === void 0 ? void 0 : _a.find((candidate) => candidate.id === userId);
        if (!user)
            return;
        const { email, phone, firstName, lastName, title, permissions, onChainAddress, avatarUrl, onChainUser } = user;
        const onChainPermissions = onChainUser ? [OnChainPermissions.ON_CHAIN_ACTIONS] : [];
        this.userInput = {
            email,
            phone,
            firstName: firstName !== null && firstName !== void 0 ? firstName : "",
            lastName: lastName !== null && lastName !== void 0 ? lastName : "",
            title,
            permissions: [...permissions, ...onChainPermissions],
            onChainAddress: onChainAddress !== null && onChainAddress !== void 0 ? onChainAddress : "",
            avatarUrl,
            newAvatar: null,
        };
    }
    getCreateUserInput() {
        const { email, phone, firstName, lastName, title, permissions, onChainAddress, newAvatar } = this.userInput;
        const standardPermissions = permissions.filter((permission) => permission !== OnChainPermissions.ON_CHAIN_ACTIONS);
        const updatedUser = {
            type: UserType.HEALTHCARE_ORGANIZATION,
            email,
            phone,
            firstName,
            lastName,
            title,
            permissions: standardPermissions,
            onChainAddress: onChainAddress === "" ? null : onChainAddress,
            newAvatar,
            onChainUser: permissions.includes(OnChainPermissions.ON_CHAIN_ACTIONS),
        };
        return updatedUser;
    }
    async performCreate() {
        if (this.opts.mode === "initialUser") {
            throw new Error("performCreate() should never be called in initialUser mode");
        }
        const updatedUser = this.getCreateUserInput();
        const userId = await this.organizationsManager.inviteUser(this.opts.organizationId, updatedUser);
        if (updatedUser.onChainUser)
            await this.organizationsManager.sendInvite(userId);
        return userId;
    }
    async forcePasswordReset() {
        if (this.opts.mode !== "detail")
            return;
        await this.organizationsManager.forcePasswordReset(this.opts.organizationId, this.opts.userId);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], GlobalAdminHealthcareOrganizationUserFormModel.prototype, "userInput", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], GlobalAdminHealthcareOrganizationUserFormModel.prototype, "isUserInvited", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminHealthcareOrganizationUserFormModel.prototype, "blockchainAddressText", null);
